<sibat-widget title="{{ 'cockpit.checklistWidget.documentation' | transloco }}">
  <mat-icon widget-icon>library_books</mat-icon>
  <div widget-content class="content">
    <sibat-primary-button
        [label]="'cockpit.checklistWidget.check-list' | transloco"
        [submit]="false"
        [disabled]="false"
        [stretch]="true"
        (clicked)="open('pdf')"
        class="start-button"
    ></sibat-primary-button>
    &nbsp;
    <sibat-primary-button
        label="Excel"
        [submit]="false"
        [disabled]="false"
        [stretch]="true"
        (clicked)="open('xlsx')"
        class="start-button"
    ></sibat-primary-button>
  </div>
</sibat-widget>
